//pM is noon allowed days are 2,7,14,21
//2017-03-17
$(document).ready(function(){
	$("<style>").text(".ui-state-highlight, .ui-widget-content .ui-state-highlight, .ui-widget-header .ui-state-highlight{ border: 1px solid #aaa;background: #fff url(images/ui-bg_glass_65_ffffff_1x400.png) 50% 50% repeat x;font-weight:normal;color #212121;}")
       .appendTo($("body"));
       
    $( "<select required='' class='required form-control' name='properties[Pickup Time]' id='pickup-time' value='Pick Time' style='display:none'></select>" ).insertAfter( "#pickup-picker" );
   	
   	
   	$("#pickup-time").on("blur",function(date){
		settime(date);
		$("#pickup-time").hide();
		$("#pickup-time").prop("disabled", true);
	});
	$("#pickup-time").on("change",function(date){
		settime(date);
		$("#pickup-time").hide();
		$("#pickup-time").prop("disabled", true);
	});
});

		var Days = $('#pickup-picker').attr('data-blockedDays');
		if (Days.indexOf("h") > -1){  var Hrs =Days.replace("h",""); Days="0";}else{Hrs=0;} 
		var natDays = buildNatHolidays();
		var nextValidPickup = nextValidPickup(Days, Hrs);

        $('#pickup-picker').datepicker({
			controlType: 'select',
			closeText: 'Go',
			minDate: nextValidPickup,//"+"+Days,
			maxDate: "+24M",
			beforeShowDay: noWeekendsOrHolidays,
		   	onSelect: function (date,inst,inst2,event){
		   		setValidHours(date);
			},
		   	onClose:  function (date,inst,inst2,event){
		   		// if no time is set
		   		if(date.length < 12){
		   			$("#pickup-time").css('display','block');
		   			$("#pickup-time").prop("disabled", false);
		   			$("#pickup-time").focus();
		   		}
			}
			
		});
		

		
		function settime(date){
			if(!date){d=$(this).val();}
			str=$('#pickup-picker').val().substr(0,10);
			str += " ";
			str += $("#pickup-time").val();
			$('#pickup-picker').val(str);
		}
		
		function setValidHours(date){
			//returns valid hours in the select for the given day
			// mon-Fri 10am to 6pm
			// sat 10am to 2 pm
			// Sunday closed
			var d = new Date(date);
			var today = new Date();
			
			$("#pickup-time").empty();
    		
    		if(d.getDay() != 0 && d.getDay() != 6){
    			d.setHours(10);
    			d.setMinutes(0);
    			var start = "10:00 AM";
    			var end = "6:00 PM";
    			
    		}else if(d.getDay()==6){
    		    d.setHours(10);
    			d.setMinutes(0);
      			var start = "10:00 AM";
    			var end = "2:00 PM";
    		}
    		var ampm = " AM";
    		var dtstr = start;
    		
    		if(d.getYear()+d.getMonth()+d.getDate() == today.getYear()+today.getMonth()+today.getDate()){
    			hr = today.getHours();
    			mn = today.getMinutes();
    			dstr = d.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
			}

    		
    		
    		
			while (dtstr != end) {
				$("#pickup-time").append('<option  value="'+dtstr+'">'+dtstr+'</option>');
				var newDateObj = new Date(d.getTime() + (15*60000));
				hr = newDateObj.getHours();
				if( hr > 12 ) {
					hr -= 12;
					ampm = " PM";
				}
				d = newDateObj
				dtstr = d.getHours()+":"+d.getMinutes()+ampm;
				dtstr = d.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
				
    			
    		}
		}
		
        function noWeekendsOrHolidays(date) {
       		var noWeekend =  noSunday(date);//$.datepicker.noWeekends(date);
       		if (noWeekend[0]) {
        		return nationalDays(date);
        	} else {
        		return noWeekend;
        	}
        }

		function nationalDays(date) {
      		for (i = 0; i < natDays.length; i++) {
        		if (date.getMonth() == natDays[i][0] - 1
                	&& date.getDate() == natDays[i][1]
               		&& date.getFullYear() == natDays[i][2]) {
                 	return [false,'', natDays[i][3] + ' day'];
               	}
      		}
         	return [true, ''];
         }
       	function noSunday(date){ 
         	return [date.getDay() != 0, ''];
     	}; 
			
		function getLastMonday(month, year) {
			//' Memorial Day          	last Mon in May
			var d = new Date();
			if (year) { d.setFullYear(year); }
			d.setDate(1); 
			d.setMonth(month || d.getMonth() + 1); 
			do { // Roll the days backwards until Monday.
				d.setDate(d.getDate() - 1);
			} while (d.getDay() !== 1);
			return d.getDate();
		}
		function getFirstMonday(month, year) {
			//' Labor Day             	first Mon in Sept
			var d = new Date();
			if (year) { d.setFullYear(year); }
			d.setDate(1); 
			d.setMonth(month-1); 
			while (d.getDay() !== 1){
				d.setDate(d.getDate() + 1);
			}
			return d.getDate();
		}
		function getfourthThurs(month, year) {
			//' Thanksgiving Day      	fourth Thur in Nov
			var d = new Date();
			var c =0;
			if (year) { d.setFullYear(year); }
			d.setDate(1);
			d.setMonth(month-1); 
			do {
              if(c != 0){
				d.setDate(d.getDate() + 1);
              }
				while (d.getDay() !== 4){
					d.setDate(d.getDate() + 1);
				}
				c++; 
			} while (c < 4);
			return d.getDate();
		}

        function buildNatHolidays(){
            // create for this year and next year
			// Closed on New Year's, Easter, Memorial, Independence, Labor, Thanksgiving, Christmas
			// ignore Easter, always a sunday
			var d = new Date();
			var tyear =d.getFullYear();
			var nyear = tyear+1; 
        	var natDays = [
        		           [1, 1, tyear, "New Year's"], [5, getLastMonday(5, tyear),tyear, "Memorial"],
        		           [7, 4, tyear, "Independence"], [9, getFirstMonday(9, tyear), tyear, "Labor"], 
        		           [11, getfourthThurs(11, tyear), tyear, "Thanksgiving"],[12, 25,tyear, "Christmas"],[12,31, tyear, "New Years Eve"],
        		           [1, 1, nyear, "New Year's"], [5, getLastMonday(5, nyear),nyear, "Memorial"],
        		           [7, 4, nyear, "Independence"], [9, getFirstMonday(9, nyear), nyear, "Labor"], 
        		           [11, getfourthThurs(11, nyear), nyear, "Thanksgiving"],[12, 25,nyear, "Christmas"],[12,31, nyear, "New Years Eve"], 
        		           [1, 1, nyear+1, "New Year's"], [5, getLastMonday(5, nyear+1),nyear+1, "Memorial"],
        		           [7, 4, nyear+1, "Independence"], [9, getFirstMonday(9, nyear+1), nyear+1, "Labor"], 
        		           [11, getfourthThurs(11, nyear+1), nyear+1, "Thanksgiving"],[12, 25,nyear+1, "Christmas"],[12,31, nyear+1, "New Years Eve"] 
        		         ];
	         return natDays;
        }
        function addZero(i) {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        }
		function nextValidPickup(Days, Hrs){
			//var hr = Hrs -1; 
			var d = new Date();
			var t = new Date();
			var hr=d.getHours()+parseInt(Hrs);
			var mn=0;
			Days = parseInt(Days);
			
			
			Days = hr>=18 ? Days+1 : Days;			
			hr = hr < 10 ||  hr >= 18 ? 10 : hr;
			
			//hr = hr > 18 ? 18 : hr;
			

			// is today valid?
			if(Days > 3){
				d.setDate(d.getDate() + Days);
			}else{
				
				var day=-1
				while (day < Days){
					var v = noWeekendsOrHolidays(d);
					if (v[0]){
						if(d.getDay() == 6){ // saturday
							//hr+=2;
							day+=1;
						}else{
							day+=1;
						} 
					}
					if(day <= Days && Days>0 ) {d.setDate(d.getDate() + 1);}
				}
			}
          
          
			if(d.getDay()== 0){// Sunday
				;
			}else if(d.getDay()== 6){ // Saturday - 10-2
				if(hr >= 13){
					hr=13;
					mn=30;
				}
			}else{ // 10-6
				if(hr >= 17){
					hr=17;
					mn=30
				}	
			}
			d.setHours(hr);// was plus 2
			d.setMinutes(mn);
			d.setSeconds(00);
			d.setMilliseconds(0)
			console.log(d)
						
			return d;
		}
//$("#pickup-picker").attr( 'readOnly' , 'true' ); // this broke the validation
$("#pickup-picker").keydown(function (event) {
    event.preventDefault();
});